import { useMemo } from 'react'
import { useAuth } from '../context/AuthContext'

export default function useRolePermissions() {
  const { user } = useAuth()

  return useMemo(() => {
    const normalizedRole = String(user?.role || '').trim().toLowerCase()
    const isViewer = normalizedRole === 'viewer'
    const isAdmin = normalizedRole === 'admin'
    const isSuperAdmin = normalizedRole === 'super admin'

    return {
      role: normalizedRole,
      isViewer,
      isAdmin,
      isSuperAdmin,
      canMutate: !isViewer,
      // Super Admin: Full access including user management
      canManageUsers: isSuperAdmin,
      // Admin: Full access except user management
      canAccessAllFeatures: isSuperAdmin || isAdmin,
      // Viewer: Can view all data but cannot perform any actions
      canViewOnly: isViewer
    }
  }, [user])
}
